const { ccclass, property } = cc._decorator;
import YXXTableViewBase from "./yxx_table_view_base";
import { EffectName } from "../effect_yxx_ctr";

@ccclass
export default abstract class YXXTableView extends YXXTableViewBase {

        //显示开奖结果
        showResulet(resuletData: any, m_callback: Function, isAmin: boolean = true) {
            if (resuletData == null){ return }
            let self = this
            for (let index = 0; index < resuletData.dice.length; index++) {
                if (this.result[index] != null){
                    this.result[index].spriteFrame = this.resultFrame[resuletData.dice[index].number - 1]
                    //这里骰宝和鱼虾蟹资源不一样 有点坑
                    if ((!this.isTb) && (resuletData.dice[index].number == 3 || resuletData.dice[index].number == 6)){
                        this.result[index].node.angle = 90
                    }
                    else{
                        this.result[index].node.angle = 0
                    }
                }
            }
            if (isAmin){
                this.effectCtr.yaogu.node.active = false
                this.effectCtr.playEffectAnim(EffectName.Result, ()=>{
                    //this.effectCtr.yaogu.node.active = true
                    if (m_callback != null){  m_callback() }
                }, false, 1)
                this.tableSound.playOpenResult()
            }
            
    
            // this.scheduleOnce(()=>{
            //     for (let index = 0; index < resuletData.dice.length; index++) {
            //         let resultAmin = this.betArea[resuletData.dice[index].number].ResultObj
            //         if ( resultAmin != null){
            //             resultAmin.node.active = true
            //             resultAmin.play()
            //             self.scheduleOnce(()=>{
            //                 resultAmin.node.active = false
            //             }, 3)
            //         }
            //     }
                
            // }, 3)
    
        }
}